import { MB, PC } from "./viewport_width";
import { isMobile } from "react-device-detect";
export default function Div(props) {
  return (
    <div
      {...props}
      style={{
        height: `${(props.height / (isMobile ? MB : PC)) * 100}vw`,
        width: `${(props.width / (isMobile ? MB : PC)) * 100}vw`,
      }}
    ></div>
  );
}
